import { computed, inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'

import { USER_TYPES } from '@core/interfaces'
import { Store } from '@core/stores'

/**
 * Guard genérico que permite acceso solo a usuarios con tipos específicos
 * @param allowedUserTypes Array de tipos de usuario permitidos
 * @returns CanActivateFn guard function
 */
export const userRoleGuard = (allowedUserTypes: USER_TYPES[]): CanActivateFn => {
  return () => {
    const store = inject(Store)
    const router = inject(Router)
    const user = computed(() => store.currentUser())

    if (user() && allowedUserTypes.includes(user()!.userType)) {
      return true
    }

    return router.parseUrl('/404')
  }
}

export const isSuperAdminGuard = userRoleGuard([USER_TYPES.SUPER_ADMIN])
export const isGerenteGuard = userRoleGuard([USER_TYPES.GERENTE])
export const isManagerOrSuperAdminGuard = userRoleGuard([USER_TYPES.GERENTE, USER_TYPES.SUPER_ADMIN])
